'use strict';

const { windowLoaded } = require('@grpn/document-states');
const { getWidth } = require('../../deal/frontend/get_dimensions');

const ThumbnailTray = require('./ThumbnailTray');
const MediaContainer = require('./MediaContainer');

const DEFAULT_RATIO = 700 / 420;

class DealCarousel {
  constructor(payload) {
    this.data = payload.carousel;
    this.$el = document.querySelector('#carousel');
    this.isLoaded = false;
    this.onLoad = this.onLoad.bind(this);

    if (this.data.showControls) {
      this.$controlForward = this.$el.querySelector(
        '.carousel-controls .forward'
      );
      this.$controlBack = this.$el.querySelector('.carousel-controls .back');
    }

    if (this.data.hasMultipleImages) {
      this.thumbnailTray = new ThumbnailTray(this.data, this.$el);
    }

    const postSwapActions = {};
    if (this.data.hasTraits) {
      Object.assign(postSwapActions, {
        triggerCarouselUpdate: () => this.triggerCarouselUpdate(),
      });
    }
    if (this.data.hasMultipleImages) {
      Object.assign(postSwapActions, {
        updateThumbnail: nextMediaObj =>
          this.thumbnailTray.jumpToThumbnail(nextMediaObj.getId()),
      });
    }

    window.DealEventPipe.on('carouselLoaded', this.onLoad);
    const onLoadAction = "DealEventPipe.trigger('carouselLoaded')";
    this.mediaContainer = new MediaContainer(
      this.data,
      this.$el,
      onLoadAction,
      postSwapActions
    );

    if (this.data.hasTraits) {
      window.DealEventPipe.on('traitsUpdate', data =>
        this.handleTraitsUpdate(data)
      );
    }

    this.fixHeight();

    windowLoaded.then(() =>
      window.Groupon.Utils.lazyLoadImages('#carousel .sleepy-load', {
        skip_invisible: true,
      })
    );

    return this;
  }

  handleTraitsUpdate(data) {
    if (this.isLoaded) {
      this.mediaContainer.handleMediaSwap('getIndexFromTraits', data, {
        triggerCarouselUpdate: undefined,
      });
    } else if (this.data.hasTraits) {
      this.traitsTriggeredDuringPreload = data;
    }
  }

  fixHeight() {
    const width = getWidth(this.$el, { margin: false, padding: false });

    const height = width / (this.data.ratio || DEFAULT_RATIO);
    this.mediaContainer.fixHeight(height, width);
  }

  onLoad() {
    if (this.isLoaded) {
      return;
    }
    this.isLoaded = true;
    this.fixHeight();
    this.mediaContainer.onLoad();

    if (this.traitsTriggeredDuringPreload) {
      this.handleTraitsUpdate(this.traitsTriggeredDuringPreload);
      this.traitsTriggeredDuringPreload = undefined;
    } else {
      if (this.data.imageZoom) {
        this.mediaContainer.setUpZoom(this.mediaContainer.currentMedia);
      }
      this.mediaContainer.preloadMedia();
    }

    if (this.data.showControls) {
      this.$controlForward.addEventListener('click', e => {
        this.mediaContainer.handleMediaSwap('incrementIndex', { e });
        if (this.mediaContainer.autoSlideShow) {
          this.mediaContainer.autoSlideShow.disable();
        }
      });
      this.$controlBack.addEventListener('click', e => {
        this.mediaContainer.handleMediaSwap('decrementIndex', { e });
        if (this.mediaContainer.autoSlideShow) {
          this.mediaContainer.autoSlideShow.disable();
        }
      });
    }

    if (this.data.hasMultipleImages) {
      this.thumbnailTray.onLoad(this.mediaContainer.getActiveId());

      [...this.thumbnailTray.$thumbnails].forEach(el =>
        el.addEventListener('click', e => {
          this.mediaContainer.handleMediaSwap(
            'getIndexByDataId',
            { e, dataId: e.currentTarget.dataset.id },
            {
              updateThumbnail: (nextMediaObj, data) =>
                this.thumbnailTray.adjustThumbnail(nextMediaObj.getId(), data),
            }
          );
          if (this.mediaContainer.autoSlideShow) {
            this.mediaContainer.autoSlideShow.disable();
          }
        })
      );
    }

    window.addEventListener('resize', () => this.fixHeight());
  }

  triggerCarouselUpdate() {
    window.DealEventPipe.trigger(
      'carouselUpdate',
      this.mediaContainer.getTraitsByIndex()
    );
  }
}

module.exports = DealCarousel;
